/* Theoric · Black 2026 · aviso na gaveta do Kaching Cart (colar no FIM do "Custom JS" do Kaching Cart)
   Mostra, logo abaixo da barra de frete do Kaching:
     "Compre 2, leve 3: falta N produto(s) para o 3º grátis"
     "Faltam R$ X para frete grátis e Icon Bag"
   - So aparece de 01/11 00:00 a 26/11 23:59 (BRT), porque o Custom JS do Kaching vale para TODOS os temas.
   - Conta so produtos avulsos: ignora kits (handle/titulo com "kit", tipo "kit" ou item com componentes) e brindes (preco 0 ou _brinde).
   - Valor do frete: total depois do desconto da campanha (totalAfterDiscounts do Kaching, senao cart.total_price), antes do Pix.
   - Nenhuma outra promessa. */
(function () {
  if (window.__theoricDrawerMsg) return; window.__theoricDrawerMsg = true;
  var INICIO = Date.parse('2026-11-01T00:00:00-03:00');
  var FIM = Date.parse('2026-11-27T00:00:00-03:00');
  var META = 49900; // centavos

  function noPeriodo() { var t = Date.now(); return t >= INICIO && t < FIM; }
  function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function ehKit(it) {
    var h = String(it.handle || '') + ' ' + String(it.product_title || it.title || '');
    return /(^|[\s-])kit([\s-]|$)/i.test(h) || /kit/i.test(String(it.product_type || '')) || !!(it.item_components && it.item_components.length);
  }
  function totalDepoisDesconto(cart) {
    try {
      var a = cart.attributes && cart.attributes._kaching_cart_attributes;
      if (a) { var j = JSON.parse(a); if (typeof j.totalAfterDiscounts === 'number') return j.totalAfterDiscounts; }
    } catch (e) {}
    return Number(cart.total_price) || 0;
  }
  function caixa() {
    var root = document.getElementById('kaching-cart'); if (!root) return null;
    var el = root.querySelector('.theoric-drawer-msg');
    if (el) return el;
    var bar = root.querySelector('.kaching-cart__tiered-promotions-bar');
    var anchor = bar ? bar.closest('.kaching-cart__module') : root.querySelector('.kaching-cart__contents > .kaching-cart__module');
    if (!anchor) return null;
    el = document.createElement('div');
    el.className = 'theoric-drawer-msg'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }
  var pend = null;
  function atualizar() {
    clearTimeout(pend);
    pend = setTimeout(function () {
      var el = caixa(); if (!el) return;
      if (!noPeriodo()) { el.hidden = true; return; }
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var n = 0;
        (cart.items || []).forEach(function (it) {
          if (ehKit(it)) return;
          if (it.properties && it.properties._brinde === 'true') return;
          if (!(it.original_price > 0)) return;
          n += Number(it.quantity) || 0;
        });
        if (!cart.item_count) { el.hidden = true; el.innerHTML = ''; return; }
        var linhas = [];
        var resto = n % 3;
        if (n > 0 && resto !== 0) {
          var falta = 3 - resto;
          linhas.push('<strong>Compre 2, leve 3:</strong> falta ' + falta + ' produto' + (falta > 1 ? 's' : '') + ' para o 3º grátis');
        }
        var faltaFrete = META - totalDepoisDesconto(cart);
        if (faltaFrete > 0) linhas.push('Faltam <strong>' + brl(faltaFrete) + '</strong> para frete grátis e Icon Bag');
        if (!linhas.length) { el.hidden = true; el.innerHTML = ''; return; }
        el.innerHTML = linhas.map(function (l) { return '<p>' + l + '</p>'; }).join('');
        el.hidden = false;
      }).catch(function () {});
    }, 150);
  }
  function observar() {
    var root = document.getElementById('kaching-cart');
    if (!root) { setTimeout(observar, 500); return; }
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].target.closest && m[i].target.closest('.theoric-drawer-msg')) return; }
      atualizar();
    }).observe(root, { childList: true, subtree: true, characterData: true });
    atualizar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observar); else observar();
})();
